import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { Observable, observe, Scope } from 'wdc-cube'
import { PriceTierEditorScope } from '../../billing/bl_scopes'
import type { GroupRow } from '../gm_scopes'
import { UserRow } from '../../user-manager/um_scopes'
import { FilterOption } from 'src/components/searchbox'

export type GroupFormTab = 'config' | 'filters' | 'billing' | 'users'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class GroupManagerFormScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope

    @observe() groupEditing?: GroupRow
    @observe() formData = {
        tcm_sb_active_filters: {},
        tc_sb_active_filters: {},
        ta_sb_active_filters: {}
    } as GroupRow

    @observe() activeTab: GroupFormTab = 'config'

    @observe() dirty = false

    @observe() formVersion = 0

    @observe() allUsers = [] as UserRow[]
    @observe() selectedUser: UserRow | undefined = undefined

    @observe() rowMenuUserId?: number

    @observe() confirmStatusChangedModalOpen = false

    @observe() billingUseDefault = true

    readonly billingTierEditor = new PriceTierEditorScope()
    readonly billingDefaultTierEditor = new PriceTierEditorScope()

    @observe() tc_filter_menu_options_array = [] as FilterOption[]
    @observe() tm_filter_menu_options_array = [] as FilterOption[]
    @observe() ta_filter_menu_options_array = [] as FilterOption[]

    onTabSelected = Scope.ASYNC_ACTION_ONE<GroupFormTab>()

    onFormDataChange = Scope.ASYNC_ACTION_ONE<Partial<GroupRow>>()
    onDiscard = Scope.ASYNC_ACTION

    onBillingUseDefaultChanged = Scope.ASYNC_ACTION_BOOLEAN

    onSelectedUserChanged = Scope.ASYNC_ACTION_ONE<UserRow | undefined>()
    onAddUserToGroup = Scope.ASYNC_ACTION
    onOpenRowMenu = Scope.ASYNC_ACTION_NUMBER
    onCloseRowMenu = Scope.ASYNC_ACTION
    onRemoveUserFromGroup = Scope.ASYNC_ACTION_NUMBER
    onSetUserToAdmin = Scope.ASYNC_ACTION_NUMBER

    onSave = Scope.ASYNC_ACTION
    onClose = Scope.ASYNC_ACTION

    onCloseModalStatusChanged = Scope.ASYNC_ACTION
    onConfirmStatusChanged = Scope.ASYNC_ACTION
}

export default GroupManagerFormScope
